export default {"src":"/_next/static/image/public/images/flags/flag_968.2e7669787f8edb093b538b0ebacb689e.svg","height":16,"width":24};